import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from '../../api/client';
import { useAuth } from '../../auth/AuthProvider';
import type { NavFlags } from '../../layout/nav';
import { useShop } from '../../shop/ShopProvider';
import { useFoodpanda } from '../foodpanda/api';

export const posConfigKey = ['pos', 'config'] as const;

/**
 * Flags for the navigation: the point of sale shows only while the shop has it switched on, and
 * Foodpanda only while the add-on is enabled for the shop. Staff
 * who can't read settings (a cashier) learn it from GET /pos/config, which pos.use may read.
 * Menus the platform admin turned off for the shop come with GET /me.
 */
export function useNavFlags(): NavFlags {
  const { status, can, me } = useAuth();
  const { settings } = useShop();
  const mayPos = status === 'signedIn' && (can('pos.use') || can('pos.manage'));
  const config = useQuery({
    queryKey: posConfigKey,
    queryFn: () => unwrap(api.GET('/pos/config')),
    enabled: mayPos && !settings,
    staleTime: 5 * 60_000,
  });
  const foodpanda = useFoodpanda();
  return {
    posEnabled: settings?.posEnabled ?? config.data?.enabled ?? false,
    foodpandaLicensed: foodpanda.licensed,
    hiddenMenus: me?.hiddenMenus ?? [],
  };
}
